import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/user-placeholder.jpg'
import _imports_1 from '../../../assets/icons/heart-icon.svg'
import _imports_2 from '@/assets/images/historical__empty.png'


const _withScopeId = n => (_pushScopeId("data-v-04545deb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "historic_project"
}
const _hoisted_2 = {
  key: 0,
  class: "content_field tw-mb-4"
}
const _hoisted_3 = { class: "sort__wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sortby_btn" }, "Sort by", -1))
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "historic_project__card_list md:!tw-mt-0"
}
const _hoisted_7 = { class: "card__header" }
const _hoisted_8 = { class: "card__header__img" }
const _hoisted_9 = {
  key: 0,
  class: "",
  src: _imports_0
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "right__block" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heart_icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_13 = { class: "card__content" }
const _hoisted_14 = { class: "card__content__header" }
const _hoisted_15 = { class: "card__info" }
const _hoisted_16 = { class: "card__info__left" }
const _hoisted_17 = { class: "card__info__right" }
const _hoisted_18 = { class: "card__info__tags" }
const _hoisted_19 = { class: "card__info__tags__default" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Exp.", -1))
const _hoisted_21 = {
  key: 0,
  class: "card__info__tags__custom"
}
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 0,
  class: "custom_tags__more"
}
const _hoisted_24 = { class: "card_project_summary" }
const _hoisted_25 = { class: "card_project_summary__list" }
const _hoisted_26 = { class: "card_project_summary__list_item" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Start Date", -1))
const _hoisted_28 = { class: "card_project_summary__list_item" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Duration", -1))
const _hoisted_30 = { class: "card_project_summary__list_item" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Cost", -1))
const _hoisted_32 = { class: "card__footer" }
const _hoisted_33 = {
  key: 2,
  class: "empty-screen md:!tw-pt-[24px] md:!tw-mt-0"
}
const _hoisted_34 = { class: "empty-screen__inner" }
const _hoisted_35 = /*#__PURE__*/_createStaticVNode("<div class=\"empty-screen__image md:!tw-max-w-[260px] md:!tw-ml-0 md:!tw-mb-[24px]\" data-v-04545deb><img src=\"" + _imports_2 + "\" alt=\"\" data-v-04545deb></div><div class=\"empty-screen__header\" data-v-04545deb><h2 data-v-04545deb>You currently don&#39;t have any requests for historic projects.</h2><p data-v-04545deb>Kick off your historic project with unparalleled speed.</p></div><div class=\"empty-screen__content\" data-v-04545deb><div class=\"empty-screen__content-item\" data-v-04545deb><div class=\"mdi mdi-check-circle\" data-v-04545deb></div><p data-v-04545deb><strong data-v-04545deb>Dispute protection</strong> as standard</p></div><div class=\"empty-screen__content-item\" data-v-04545deb><div class=\"mdi mdi-check-circle\" data-v-04545deb></div><p data-v-04545deb>Deposits secured <strong data-v-04545deb>in Escrow</strong></p></div><div class=\"empty-screen__content-item\" data-v-04545deb><div class=\"mdi mdi-check-circle\" data-v-04545deb></div><p data-v-04545deb> Verified trade contractors <strong data-v-04545deb>in your local area</strong></p></div></div>", 3)
const _hoisted_38 = { class: "empty-screen__footer" }

import { onMounted, ref, computed, watchEffect } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import moment from "moment";
import { USER_STORE } from "@/store/modules/user";
import { JOBS_STORE } from "@/store/modules/jobs";
import { WORKSTATION } from "@/store/modules/workstation";
import CustomBadge from "@/core/uni-components/CustomBadge.vue";
import { HistoricProjectStatusEnum } from "@/core/enums/ProjectsEnum";
import CurrencyFilter from "@/filters/currency.filter";
import {
  getImageStringToImageURL,
  getUserSubSkillList,
} from "@/core/utils/common";
import Text from "@/core/uni-components/Text.vue";
import InputField from "@/core/uni-components/InputField.vue";
import Button from "@/core/uni-components/Button.vue";
import EstimateBadge from "@/core/uni-components/EstimateBadge.vue";
import { BusinessDetailTypeEnum } from "@/core/enums/RolesEnum";
import CommonLoader from "@/core/components/CommonLoader.vue";
import { EstimateTypeForDeposit } from "@/core/enums/estimateEnum";
import { HISTORIC_PROJECT_DETAILS_ROUTE } from "../routes";
import PropertyListComponent from "./PropertyListComponent.vue";
import Loader from "@/core/components/common/Loader.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HistoricProjectComponent',
  props: ["toggleTabList"],
  setup(__props) {

const props = __props;
const showBanner = ref(true);
const isLoading = ref(true);
const contractorsImages: any = ref({});
const refId = ref() as any;
const estimateId = ref() as any;
const showProjectDetails = ref(false);
const searchValue = ref("");
const sortBy = ref("DESC");
const store = useStore();
const router = useRouter();
const isOpenNewProject = ref(false);

const viewProject = (refId: number, estimateId: number) => {
  router.push({
    name: HISTORIC_PROJECT_DETAILS_ROUTE,
    params: { refId, estimateId },
  });
};

const closeProject = () => {
  refId.value = null;
  estimateId.value = null;
  showProjectDetails.value = false;
  props.toggleTabList(true);
};

const historicProjects = computed(() => {
  return (
    store.getters[`${JOBS_STORE}/getHistoricalJobs`].filter(
      (obj: any) =>
        obj.project.projectHistoricalStatus == HistoricProjectStatusEnum.PENDING
    ) || []
  );
});

const filterHistoricProjects = computed(() => {
  let projects = historicProjects.value.filter((project: any) =>
    project.userWorkstation?.name
      ?.toLowerCase()
      .includes(searchValue.value?.toLowerCase())
  );
  if (sortBy.value == "ASC") projects.reverse();
  return projects;
});

watchEffect(async () => {
  await setProfileImageUrl(historicProjects.value);
});

async function setProfileImageUrl(proj: any) {
  for (const { projectCreator } of proj) {
    if (projectCreator?.userPublicProfile?.profileImage) {
      contractorsImages.value[projectCreator.id] =
        await getImageStringToImageURL(
          projectCreator.userPublicProfile.profileImage
        );
    }
  }
}

const activeUserWorkstation = computed(
  () => store.getters[`${WORKSTATION}/activeUserWorkstation`]
);

const getAllSpecialism = computed(
  () => store.getters[`${USER_STORE}/getAllSpecialism`]
);

const getUserSkillList = (userSkill: any) => {
  return getUserSubSkillList(userSkill, getAllSpecialism.value);
};

const formatDate = (startDate: string) => {
  if (!startDate) {
    return "N/A";
  }
  const date = new Date(startDate);
  const options = { day: "2-digit", month: "long", year: "numeric" } as any;
  return date.toLocaleDateString("en-GB", options);
};

const formatDuration = (sDate: any, eDate: any) => {
  if (!sDate || !eDate) {
    return 0;
  }

  const startDate = moment(sDate) as any;
  const endDate = moment(eDate) as any;

  const totalDays = endDate.diff(startDate, "days");

  if (totalDays % 7 === 0) {
    const totalWeeks = totalDays / 7;
    return `${totalWeeks} week${totalWeeks > 1 ? "s" : ""}`;
  }

  return `${totalDays} day${totalDays > 1 ? "s" : ""}`;
};
const getEstimateBadge = (selectedEstimate: any) => {
  if (selectedEstimate?.depositType === EstimateTypeForDeposit.Initial_Estimate)
    return "Initial Estimate";
  else if (
    selectedEstimate?.depositType ===
    EstimateTypeForDeposit.Fixed_Cost_Estimation
  )
    return "Fixed Cost Estimation";
  else if (
    selectedEstimate?.depositType ===
    EstimateTypeForDeposit.Variable_Cost_Estimation
  )
    return "Variable Cost Estimation";
  else return "";
};

onMounted(async () => {
  isLoading.value = true;
  try {
    if (!getAllSpecialism.value.length) {
      await store.dispatch(
        `${USER_STORE}/setAllSpecialismsCategory`,
        activeUserWorkstation.value.id
      );
    }
    await store.dispatch(`${JOBS_STORE}/fetchHistoricalProjects`);
    console.log("historicProjects", historicProjects.value);
  } catch (error) {
    console.log("error", error);
  } finally {
    isLoading.value = false;
  }
});
const openNewProject = () => {
  isOpenNewProject.value = true;
};
const onClickBackButton = () => {
  isOpenNewProject.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!showProjectDetails.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (filterHistoricProjects.value?.length && !isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_v_text_field, {
                  "prepend-inner-icon": "mdi-magnify",
                  class: "input_field",
                  placeholder: "Search",
                  variant: "outlined",
                  modelValue: searchValue.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createVNode(_component_v_menu, {
                    "close-on-content-click": false,
                    persistent: true
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps(props, {
                        variant: "plain",
                        class: "sort__btn"
                      }), {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: require('@/assets/icons/sort.svg'),
                            alt: ""
                          }, null, 8, _hoisted_5)
                        ]),
                        _: 2
                      }, 1040)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, { class: "dropdown__sort sort_dropdown_inner" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_radio_group, {
                                modelValue: sortBy.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((sortBy).value = $event))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_radio, {
                                    label: "Most Recent",
                                    value: "ASC",
                                    color: "indigo"
                                  }),
                                  _createVNode(_component_v_radio, {
                                    label: "Oldest",
                                    value: "DESC",
                                    color: "indigo"
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (!isLoading.value && filterHistoricProjects.value?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterHistoricProjects.value, (item) => {
                  return (_openBlock(), _createBlock(_component_v_card, {
                    key: item.id,
                    class: "historic_project__card__item"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          (!contractorsImages.value[item?.projectCreator.id])
                            ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                            : (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                class: "",
                                src: contractorsImages.value[item?.projectCreator.id]
                              }, null, 8, _hoisted_10))
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(EstimateBadge, {
                            badge: getEstimateBadge(item?.project?.projectEstimation[0]),
                            bgColor: "#C19F5F"
                          }, null, 8, ["badge"]),
                          _hoisted_12
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("h5", null, _toDisplayString(item?.projectCreator?.firstName) + " " + _toDisplayString(item?.projectCreator?.lastName), 1),
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("span", null, _toDisplayString(_unref(BusinessDetailTypeEnum).SOLETRADER ===
                    item?.projectCreator?.userBusinessDetails?.type
                      ? "Solo Trader"
                      : "Limited Company") + " | ", 1),
                              _createElementVNode("span", null, [
                                _createVNode(_component_v_icon, {
                                  icon: "mdi-map-marker",
                                  size: "x-small"
                                }),
                                _createTextVNode(" " + _toDisplayString(item?.projectCreator?.postcode || "NA"), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _createVNode(_component_v_icon, {
                                icon: "mdi-star",
                                color: "#FFA500"
                              }),
                              _createElementVNode("span", null, _toDisplayString(item?.ratings || 0) + "/5 (" + _toDisplayString(item?.jobsCompleted) + " Jobs)", 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createVNode(_component_v_icon, {
                              icon: "mdi-check-circle",
                              color: "#1fb27a"
                            }),
                            _createElementVNode("p", null, [
                              _createTextVNode(_toDisplayString(item?.userWorkstation?.experience || "NA") + " ", 1),
                              _hoisted_20
                            ])
                          ]),
                          (
                item.projectCreator?.userSkills &&
                item.projectCreator?.userSkills.length
              )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getUserSkillList(
                  item.projectCreator?.userSkills
                ).slice(0, 1), (skill) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "custom_tags",
                                    key: skill.id
                                  }, [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => [
                                        (skill?.iconName)
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 0,
                                              src: 
                      require('@/assets/category-icons/' +
                        skill?.iconName +
                        '.svg')
                    
                                            }, null, 8, _hoisted_22))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createElementVNode("span", null, _toDisplayString(skill?.label), 1)
                                  ]))
                                }), 128)),
                                (
                  getUserSkillList(item.projectCreator?.userSkills).length > 1
                )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                      _createElementVNode("span", null, " +" + _toDisplayString(getUserSkillList(item.projectCreator?.userSkills).length - 1) + " More ", 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _hoisted_27,
                              _createElementVNode("span", null, _toDisplayString(formatDate(item.project?.startDate)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                              _hoisted_29,
                              _createElementVNode("span", null, _toDisplayString(formatDuration(
                      item.project?.startDate,
                      item.project?.endDate
                    )), 1)
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                              _hoisted_31,
                              _createElementVNode("span", null, _toDisplayString(_unref(CurrencyFilter).formatToCurrency(
                    item?.project?.projectEstimation[0]?.totalEstimateCost
                  )), 1)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_v_btn, {
                          class: "button button-orange",
                          width: "100%",
                          onClick: ($event: any) => (
              viewProject(item.project?.refId, item.project?.projectEstimateId)
            )
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("VIEW PROJECT")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (!filterHistoricProjects.value?.length && !isLoading.value && !isOpenNewProject.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("div", _hoisted_38, [
                    _createVNode(_component_v_btn, {
                      class: "button button-purple",
                      onClick: openNewProject,
                      block: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Start a new project ")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode(Loader, { class: "tw-mt-[250px]" }, null, 512), [
            [_vShow, isLoading.value]
          ])
        ]))
      : _createCommentVNode("", true),
    (isOpenNewProject.value)
      ? (_openBlock(), _createBlock(PropertyListComponent, {
          key: 1,
          onOnClickBackButton: onClickBackButton
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})